import { isNotEmpty } from "../utils/utils";


const createQuery = (loadOptions: any) => {
    let params = '';
    if (loadOptions.skip !== undefined) params += `?skip=${loadOptions.skip}`;
    if (loadOptions.take !== undefined) params += `&take=${loadOptions.take}`;
    if (loadOptions.filter !== undefined) params += `&${loadOptions.filter[0]}=${loadOptions.filter[2]}`;

    return params;
}

const processLoadOptions = (loadOptions: any): any => {
    const params: any = {};
    [
        "filter",
        "group",
        "groupSummary",
        "parentIds",
        "requireGroupCount",
        "requireTotalCount",
        "searchExpr",
        "searchOperation",
        "searchValue",
        "select",
        "sort",
        "skip",
        "take",
        "totalSummary",
        "userData"
    ].forEach(function (i) {
        if (i in loadOptions && isNotEmpty(loadOptions[i])) {
            params[i] = JSON.stringify(loadOptions[i]);
        }
    });
    return params;
}

export {createQuery, processLoadOptions}